// src/app/store/auth/auth.actions.ts
import { createAction, props } from '@ngrx/store';
export const setAccessToken = createAction(
  '[Auth] Set AccessToken',
  props<{
    accessToken: {
      idToken?: string;
      refreshToken?: string;
      accessToken: string;
      tokenType: string;
      expiresIn: string;
    };
  }>()
);
export const clearAuth = createAction('[Auth] Clear');

export const logout = createAction('[Auth] Logout');
export const redirect = createAction('[Auth] Redirect');

// opcional si llamas a una API de revoke:
export const logoutSuccess = createAction('[Auth] Logout Success');
export const logoutFailure = createAction(
  '[Auth] Logout Failure',
  props<{ error: any }>()
);
